webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(119);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(103);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _veeValidate = __webpack_require__(102);
	
	var _veeValidate2 = _interopRequireDefault(_veeValidate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_veeValidate2.default, {
	  fieldsBagName: 'veeFields' });
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(51);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _lodash = __webpack_require__(95);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _sweetalert = __webpack_require__(100);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	__webpack_require__(85);
	
	__webpack_require__(94);
	
	var _Switcher = __webpack_require__(108);
	
	var _Switcher2 = _interopRequireDefault(_Switcher);
	
	var _Radio = __webpack_require__(105);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	var _Range = __webpack_require__(106);
	
	var _Range2 = _interopRequireDefault(_Range);
	
	var _Checkbox = __webpack_require__(104);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _TextBlock = __webpack_require__(109);
	
	var _TextBlock2 = _interopRequireDefault(_TextBlock);
	
	var _TextInput = __webpack_require__(110);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Selection = __webpack_require__(107);
	
	var _Selection2 = _interopRequireDefault(_Selection);
	
	var _randomSentence = __webpack_require__(25);
	
	var _randomSentence2 = _interopRequireDefault(_randomSentence);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var comps = ['TextBlock', 'Selection', 'Radio', 'Range', 'Checkbox', 'TextInput', 'Switcher'];
	var texBlockCnt = 0;
	exports.default = {
		name: 'app',
		components: {
			Radio: _Radio2.default,
			Range: _Range2.default,
			Switcher: _Switcher2.default,
			Checkbox: _Checkbox2.default,
			TextBlock: _TextBlock2.default,
			TextInput: _TextInput2.default,
			Selection: _Selection2.default
		},
		methods: {
			bite: function bite() {
				return (0, _randomSentence2.default)({ min: 1, max: 2 });
			},
			randomComp: function randomComp() {
				var arr = comps;
				if (texBlockCnt > 1) {
					arr = comps.filter(function (item) {
						return item !== 'TextBlock';
					});
				}
	
				var result = _lodash2.default.sample(arr);
				if (result === "TextBlock") texBlockCnt++;
				return result;
			},
			validateAllInputs: function validateAllInputs() {
				var validatings = this.$refs.inputs.map(function (input) {
					return input.$validator.validateAll();
				});
				_promise2.default.all(validatings).then(function () {
					(0, _sweetalert2.default)({
						title: (0, _randomSentence2.default)({ min: 4, max: 8 }),
						text: (0, _randomSentence2.default)({ min: 2, max: 4 }),
						type: (0, _randomSentence2.default)({ min: 1, max: 2 }),
						showCancelButton: true,
						confirmButtonText: (0, _randomSentence2.default)({ min: 1, max: 5 }),
						confirmButtonColor: '#00d1b2',
						cancelButtonText: (0, _randomSentence2.default)({ min: 1, max: 5 }),
						cancelButtonColor: '#ffdd57'
					}).then(function () {
						window.location.reload(true);
					}, function (dismiss) {
						if (dismiss === 'cancel') {
							_sweetalert2.default.close();
						}
					});
				}).catch(function (err) {
					(0, _sweetalert2.default)({
						title: (0, _randomSentence2.default)({ min: 1, max: 2 }),
						text: (0, _randomSentence2.default)({ min: 4, max: 8 }),
						type: 'error',
						showCloseButton: true,
						confirmButtonText: (0, _randomSentence2.default)({ min: 1, max: 5 }),
						confirmButtonColor: '#ff3860'
					}).then(function () {
						window.location.reload(true);
					}, function (dismiss) {});
				});
			},
			cleanAllErrors: function cleanAllErrors() {
				this.$refs.inputs.forEach(function (input) {
					input.errors.clear();
				});
			}
		}
	};

/***/ },
/* 44 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		data: function data() {
			return {
				checkboxName: ''
			};
		},
		created: function created() {
			this.checkboxName = 'checkbox' + this._uid;
		}
	};

/***/ },
/* 45 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'radio',
		data: function data() {
			return {
				switchFlag: false,
				msg: 'Welcome to Your Vue.js App',
				picked: ''
			};
		},
	
		computed: {
			radioGroupName: function radioGroupName() {
				return 'radio' + this._uid;
			}
		},
		created: function created() {
			this.switchFlag = _.random(1) == 0;
		}
	};

/***/ },
/* 46 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		data: function data() {
			return {
				targetValue: 0,
				leftPos: 0
			};
		},
		created: function created() {
			var pos = [3, 34, 65, 95, 126];
			this.targetValue = _.sample([1, 2, 3, 4]);
			this.leftPos = pos[this.targetValue];
		}
	};

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _randomSentence = __webpack_require__(25);
	
	var _randomSentence2 = _interopRequireDefault(_randomSentence);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'selection',
		data: function data() {
			return {
				targetValue: '',
				options: []
			};
		},
		created: function created() {
			var count = _.random(2, 7);
			var curIndex = _.random(1, count - 1);
			var options = [];
	
			for (var i = 0; i < count; i++) {
				options.push((0, _randomSentence2.default)({ min: 1, max: 3 }));
			}
			this.targetValue = options[curIndex];
			this.options = options;
		}
	};

/***/ },
/* 48 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		data: function data() {
			return {
				checkboxName: '',
				expression: {
					rules: {
						required: true
					}
				}
			};
		},
		created: function created() {
			this.checkboxName = 'checkbox' + this._uid;
		}
	};

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _randomParagraph = __webpack_require__(98);
	
	var _randomParagraph2 = _interopRequireDefault(_randomParagraph);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'hello',
		data: function data() {
			return {
				placeHold: '',
				value: '',
				vali: { rules: { required: true, in: [] } }
			};
		},
	
		methods: {
			randomParagraph: function randomParagraph() {
				return (0, _randomParagraph2.default)({ min: 1, max: 2 });
			}
		},
		created: function created() {
			var randPara = this.randomParagraph();
			this.placeHold = randPara;
			this.vali.rules.in[0] = randPara;
		}
	};

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _randomLorem = __webpack_require__(41);
	
	var _randomLorem2 = _interopRequireDefault(_randomLorem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				placeHold: '',
				value: '',
				vali: { rules: { required: true, in: [] } }
			};
		},
	
		methods: {
			randomWords: function randomWords() {
				return (0, _randomLorem2.default)({ min: 2, max: 12 });
			}
		},
		created: function created() {
			var randWord = this.randomWords();
			this.placeHold = randWord;
			this.vali.rules.in[0] = randWord;
		}
	};

/***/ },
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 86 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 87 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 88 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 89 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 90 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 91 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 92 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 93 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 94 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(93)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(43),
	  /* template */
	  __webpack_require__(118),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(88)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(44),
	  /* template */
	  __webpack_require__(113),
	  /* scopeId */
	  "data-v-32698206",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(90)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(45),
	  /* template */
	  __webpack_require__(115),
	  /* scopeId */
	  "data-v-68164a31",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(91)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(46),
	  /* template */
	  __webpack_require__(116),
	  /* scopeId */
	  "data-v-751dfe73",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(86)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(47),
	  /* template */
	  __webpack_require__(111),
	  /* scopeId */
	  "data-v-20e1b842",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(92)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(48),
	  /* template */
	  __webpack_require__(117),
	  /* scopeId */
	  "data-v-9c17a9ca",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(87)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(49),
	  /* template */
	  __webpack_require__(112),
	  /* scopeId */
	  "data-v-27500016",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(89)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(50),
	  /* template */
	  __webpack_require__(114),
	  /* scopeId */
	  "data-v-590dacd3",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 111 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "control column"
	  }, [_c('span', {
	    staticClass: "select"
	  }, [_c('select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        rules: {
	          required: true,
	          in: [_vm.targetValue]
	        }
	      }),
	      expression: "{ rules: { required: true, in: [targetValue] } }"
	    }],
	    class: {
	      'is-danger': _vm.errors.has('selection')
	    },
	    attrs: {
	      "data-vv-name": "selection"
	    }
	  }, _vm._l((_vm.options), function(op) {
	    return _c('option', [_vm._v(_vm._s(op))])
	  }))]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('selection')),
	      expression: "errors.has('selection')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v("\n\t\tX\n\t")])])
	},staticRenderFns: []}

/***/ },
/* 112 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('p', [_vm._v(_vm._s(_vm.placeHold))]), _vm._v(" "), _c('p', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('textarea')),
	      expression: "errors.has('textarea')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v("X")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: (_vm.vali),
	      expression: "vali"
	    }, {
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.value),
	      expression: "value",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "topcoat-textarea",
	    class: {
	      'is-danger': _vm.errors.has('textarea')
	    },
	    attrs: {
	      "data-vv-name": "textarea",
	      "placeholder": _vm.placeHold
	    },
	    domProps: {
	      "value": _vm._s(_vm.value)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.value = $event.target.value.trim()
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ },
/* 113 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('label', {
	    staticClass: "topcoat-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "name": _vm.checkboxName
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "topcoat-checkbox__checkmark",
	    class: {
	      'is-danger': _vm.errors.has(_vm.checkboxName)
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has(_vm.checkboxName)),
	      expression: "errors.has(checkboxName)"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v("\n\t\t\tX\n\t\t")])])])
	},staticRenderFns: []}

/***/ },
/* 114 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('span', [_vm._v(_vm._s(_vm.placeHold))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: (_vm.vali),
	      expression: "vali"
	    }, {
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.value),
	      expression: "value",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "topcoat-text-input",
	    class: {
	      'is-danger': _vm.errors.has('text')
	    },
	    attrs: {
	      "type": "text",
	      "data-vv-name": "text",
	      "placeholder": _vm.placeHold
	    },
	    domProps: {
	      "value": _vm._s(_vm.value)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.value = $event.target.value.trim()
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('text')),
	      expression: "errors.has('text')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v("X")])])
	},staticRenderFns: []}

/***/ },
/* 115 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.switchFlag) ? [_c('label', {
	    staticClass: "topcoat-radio-button"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.picked),
	      expression: "picked"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        rules: {
	          required: true,
	          in: ['yes']
	        }
	      }),
	      expression: "{ rules: { required: true, in:['yes'] } }"
	    }],
	    class: {
	      'is-danger': _vm.errors.has(_vm.radioGroupName)
	    },
	    attrs: {
	      "name": _vm.radioGroupName,
	      "type": "radio",
	      "value": "yes"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.picked, "yes")
	    },
	    on: {
	      "click": function($event) {
	        _vm.picked = "yes"
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "topcoat-radio-button__checkmark",
	    class: {
	      'is-danger': _vm.errors.has(_vm.radioGroupName)
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "topcoat-radio-button"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.picked),
	      expression: "picked"
	    }],
	    attrs: {
	      "name": _vm.radioGroupName,
	      "type": "radio",
	      "value": "no"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.picked, "no")
	    },
	    on: {
	      "click": function($event) {
	        _vm.picked = "no"
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "topcoat-radio-button__checkmark",
	    class: {
	      'is-danger': _vm.errors.has(_vm.radioGroupName)
	    }
	  })])] : [_c('label', {
	    staticClass: "topcoat-radio-button"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.picked),
	      expression: "picked"
	    }],
	    attrs: {
	      "name": _vm.radioGroupName,
	      "type": "radio",
	      "value": "no"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.picked, "no")
	    },
	    on: {
	      "click": function($event) {
	        _vm.picked = "no"
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "topcoat-radio-button__checkmark",
	    class: {
	      'is-danger': _vm.errors.has(_vm.radioGroupName)
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "topcoat-radio-button"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.picked),
	      expression: "picked"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        rules: {
	          required: true,
	          in: ['yes']
	        }
	      }),
	      expression: "{ rules: { required: true, in:['yes'] } }"
	    }],
	    class: {
	      'is-danger': _vm.errors.has(_vm.radioGroupName)
	    },
	    attrs: {
	      "name": _vm.radioGroupName,
	      "type": "radio",
	      "value": "yes"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.picked, "yes")
	    },
	    on: {
	      "click": function($event) {
	        _vm.picked = "yes"
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "topcoat-radio-button__checkmark",
	    class: {
	      'is-danger': _vm.errors.has(_vm.radioGroupName)
	    }
	  })])], _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has(_vm.radioGroupName)),
	      expression: "errors.has(radioGroupName)"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v("\n\t\tX\n\t")])], 2)
	},staticRenderFns: []}

/***/ },
/* 116 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        rules: {
	          required: true,
	          in: [_vm.targetValue]
	        }
	      }),
	      expression: "{ rules: { required: true, in: [targetValue] } }"
	    }],
	    staticClass: "topcoat-range",
	    attrs: {
	      "type": "range",
	      "data-vv-name": "slider",
	      "step": "1",
	      "min": "0",
	      "max": "4",
	      "value": "0",
	      "list": "numbers"
	    }
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
	    staticClass: "arrow-down",
	    class: {
	      'is-danger': _vm.errors.has('slider')
	    },
	    style: ({
	      left: _vm.leftPos + 'px'
	    })
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('slider')),
	      expression: "errors.has('slider')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v("\n\t\tX\n\t")])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('datalist', {
	    attrs: {
	      "id": "numbers"
	    }
	  }, [_c('option', [_vm._v("0")]), _vm._v(" "), _c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")])])
	}]}

/***/ },
/* 117 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('label', {
	    staticClass: "topcoat-switch",
	    class: {
	      'is-danger': _vm.errors.has(_vm.checkboxName)
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: (_vm.expression),
	      expression: "expression"
	    }],
	    staticClass: "topcoat-switch__input",
	    attrs: {
	      "type": "checkbox",
	      "name": _vm.checkboxName
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "topcoat-switch__toggle"
	  })]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has(_vm.checkboxName)),
	      expression: "errors.has(checkboxName)"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v("X")])])
	},staticRenderFns: []}

/***/ },
/* 118 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "container is-fluid",
	    attrs: {
	      "id": "quest"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, _vm._l((300), function(n) {
	    return _c(_vm.randomComp(), {
	      ref: "inputs",
	      refInFor: true,
	      tag: "component"
	    })
	  }))]), _vm._v(" "), _c('footer', {
	    staticClass: "footer"
	  }, [_c('div', {
	    staticClass: "container",
	    attrs: {
	      "id": "biteme"
	    }
	  }, [_c('button', {
	    staticClass: "topcoat-button--large--cta",
	    on: {
	      "click": _vm.validateAllInputs
	    }
	  }, [_vm._v(_vm._s(_vm.bite()))])])])])
	},staticRenderFns: []}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.ef0f5f4d6c7a7b0a1df9.js